import React from 'react';
import axios from 'axios';
import VirtualStamp from '@/components/shared/Grading/VirtualStamps/VirtualStamp';
import * as Routes from '@/modules/routes';
import { TeacherCommentType } from '../../hooks/useQuestionAnswers';
import useGradesTableStore from '../../store/useGradesTableStore';

type CommentCardProps = {
  assignmentId: number;
  comment: TeacherCommentType;
};

const CommentCard = ({ assignmentId, comment } : CommentCardProps) => {
  const classroomId = useGradesTableStore(state => state.classroom.id);
  const studentId = useGradesTableStore(state => state.student.id);

  const handleRedirectByModel = () => {
    axios
      .get(Routes.plato_api_student_exercise_path_by_model_assignment_path(assignmentId,
        {
          classroom_id: classroomId,
          student_id: studentId,
        })).then(res => window.open(res.data.data.redirect_to, '_blank'));
  };

  return (
    <div className="tw-w-full tw-border tw-border-med-grey tw-border-solid tw-mb-3 last:tw-mb-12">
      <div className="tw-my-4 tw-ml-4 tw-flex tw-gap-x-4 tw-justify-start tw-items-center">
        <p className="tw-m-0"> Question {comment.display_position} </p>
        <button
          className="tw-hidden btn btn--link-purple tw-text-blue !tw-p-0"
          type="button"
          onClick={handleRedirectByModel}
        > Go to Question
        </button>
      </div>
      <div className="tw-flex tw-items-start tw-justify-start tw-mb-2 tw-px-4 tw-gap-x-4">
        {comment.teacher_stamp && (
          <div className="tw-h-[80px] tw-w-[80px]">
            <VirtualStamp stampName={comment.teacher_stamp} />
          </div>
        )}
        <p className="tw-text-dark-grey">{comment.teacher_comment}</p>
      </div>
    </div>
  );
};

export default CommentCard;
